<template lang="pug">
#filter-tags
  b-taglist
    b-tag(
      v-for="tag in tags"
      size="is-medium"
      type="is-primary"
      :closable="true"
      :key="tag.id"
      :rounded="true"
      @close="close(tag)"
    )
      b-icon(:icon="tag._icon")
      span {{ tag._label }}
</template>

<script>
import { mapGetters } from 'vuex';
import * as getters from '@/store/types/getters';
import * as mutations from '@/store/types/mutations';

export default {
  name: 'filter-tags',
  computed: {
    ...mapGetters({
      eventTags: getters.GET_EVENTS_TAGS,
      mediaTags: getters.GET_MEDIA_TAGS,
    }),
    tags() {
      switch (this.mode) {
        case 'events':
          return this.eventTags;
        case 'media':
          return this.mediaTags;
        default:
          return [];
      }
    },
  },
  methods: {
    close(tag) {
      const mode = this.mode.toUpperCase();
      this.$store.commit(mutations[`TOGGLE_${mode}_TAG`], tag);
      this.$store.commit(mutations[`SET_${mode}_REFRESH`], true);
    },
  },
  props: {
    mode: {
      type: String,
      default: 'media',
    },
  },
};
</script>

<style lang="scss">
#filter-tags {
  display: flex;
  .tags {
    .tag {
      & > span {
        display: flex;
        align-items: center;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/FilterTags.vue